/// <reference types="@angular/localize" />

import { enableProdMode, APP_INITIALIZER, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { getProductionEnabled, getBasePath } from './config';
import { AppComponent } from './app/app.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { provideAnimations } from '@angular/platform-browser/animations';
import {provideTranslateHttpLoader, TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateModule, TranslateLoader, provideTranslateService} from '@ngx-translate/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AuthInterceptor } from './app/interceptors/auth.interceptor';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { Overlay } from '@angular/cdk/overlay';
import { MAT_DATEPICKER_SCROLL_STRATEGY } from '@angular/material/datepicker';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { customIconsInitializeFactory } from './app/utils';
import { CustomIconsService } from './app/services/custom-icons.service';
import { NbIconLibraries, NbThemeModule, NbLayoutModule, NbSidebarModule, NbMenuModule, NbDialogModule, NbDatepickerModule, NbTimepickerModule, NbToastrModule, NbCardModule } from '@nebular/theme';
import { BASE_PATH, ApiModule } from './api-new';
import {provideRouter} from "@angular/router";
import {routes} from "./app/routes";
import '@angular/common/locales/global/sk';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
  provideMomentDateAdapter
} from "@angular/material-moment-adapter";

if (getProductionEnabled()) {
  enableProdMode();
}



export const SLOVAK_DATE_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY', // Parsing user input
  },
  display: {
    dateInput: 'DD.MM.YYYY', // Shown in date inputs
    monthYearLabel: 'MMMM YYYY', // Shown on selecting months/years
    dateA11yLabel: 'DD.MM.YYYY', // For accessibility
    monthYearA11yLabel: 'MMMM YYYY', // For accessibility
  },
};

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    { provide: LOCALE_ID, useValue: 'sk' },
    provideTranslateService({
      loader:
        provideTranslateHttpLoader({
          prefix: 'assets/i18n/lang_',
          suffix: '.json',
        }),
      defaultLanguage: 'sk',
    }),
    importProvidersFrom(
     NbThemeModule.forRoot({ name: 'corporate' }),
      NbLayoutModule,
      NbEvaIconsModule,
      NbSidebarModule.forRoot(),
      NbMenuModule.forRoot(),
      NbDialogModule.forRoot(),
      NbDatepickerModule.forRoot(),
      NbTimepickerModule.forRoot(),
      NbToastrModule.forRoot(),
      NbDateFnsDateModule.forRoot({ format: 'dd.MM.yyyy' }),
      ApiModule,
      NbCardModule,
      MatNativeDateModule,
      MatInputModule,
      MatAutocompleteModule,
      MatSelectModule,
      MatMenuModule,
      MatButtonModule,
      MatIconModule,
      MatDialogModule
    ),
    {
      provide: BASE_PATH,
      useValue: getBasePath()
    },
    provideMomentDateAdapter(SLOVAK_DATE_FORMATS, {useUtc:true}),
    { provide: MAT_DATE_LOCALE, useValue: 'sk-SK' },
    { provide: MAT_DATE_FORMATS, useValue: SLOVAK_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [NbIconLibraries, CustomIconsService],
      useFactory: customIconsInitializeFactory
    },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    {
      provide: MAT_DATEPICKER_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.block(),
      deps: [Overlay]
    },
    { provide: LOCALE_ID, useValue: 'sk' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi())
  ]
})
  .catch(err => console.error(err));
